import { t } from 'i18next';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import { DashboardCard } from '../../../components';
import { useOutstandingQuoteRequests, usePermission } from '../../../hooks';
import { UserPermission } from '../../../enums';
import * as Sx from './Dashboard.styles';

export const QuoteRequestsCard: React.FC = () => {
  const { hasAllPermissions } = usePermission();
  const { list: quotes } = useOutstandingQuoteRequests(
    !hasAllPermissions([
      UserPermission.RequestQuotes,
      UserPermission.ViewCorporateQuotes,
    ])
  );

  return (
    <DashboardCard
      icon={<RequestQuoteIcon sx={Sx.icon} />}
      link="/corporate-user/quotes"
      linkText={t('dashboard.quotes')}
      message={quotes?.length?.toString() ?? 0}
      title={t('dashboard.quoteRequests')}
    />
  );
};
